export default __webpack_public_path__ + "static/media/ALB.100b009d.svg";